export default "__VITE_ASSET__BYcedWhF__"